'use strict';
var $ = require('jquery');

$(function() {
    var filter = "";
    $('.reference-filter-btn').on('click', function(){
        $('.reference-filter-btn').removeClass('active');
        $(this).addClass('active');
        filter = $(this).data('reftype');
        if(filter == 'all'){
            $('.single-reference').fadeIn();
        }else{
            $('.single-reference').hide();
            $('.single-reference[data-postterms*=' + filter + ']').fadeIn(300);
        }
    });
});
